// edge/customBezierEdge.ts
import { 
  BezierEdge, 
  BezierEdgeModel, 
  PolylineEdge, 
  PolylineEdgeModel 
} from '@logicflow/core';
import { getShapeStyleFuction } from '../utils/getShapeStyleUtil';

// 1. 曲线连线实现（CustomBezier）
class BezierModel extends BezierEdgeModel {
  constructor(data, graphModel) {
    super(data, graphModel); // 必须调用父类构造函数
    // 曲线样式配置
    this.strokeWidth = 1;
    this.radius = 10; // 曲线弧度
  }

  // 自定义曲线样式
  getEdgeStyle() {
    const attributes = super.getEdgeStyle();
    return getShapeStyleFuction(attributes, this.properties);
  }
}

export const CustomBezier = {
  type: 'custom-bezier', // 类型名必须和组件中使用的一致
  view: BezierEdge,
  model: BezierModel
};

// 2. 折线连线实现（CustomPolyline）
class PolylineModel extends PolylineEdgeModel {
  constructor(data, graphModel) {
    super(data, graphModel); // 必须调用父类构造函数
    // 折线样式配置
    this.strokeWidth = 1;
    this.offset = 20; // 折线拐角偏移量
  }

  // 自定义折线样式
  getEdgeStyle() {
    const attributes = super.getEdgeStyle();
    return getShapeStyleFuction(attributes, this.properties);
  }
}

export const CustomPolyline = {
  type: 'custom-polyline', // 类型名必须和组件中使用的一致
  view: PolylineEdge,
  model: PolylineModel
};